import React from "react";
import "./App.css";
import "react-router-dom"; //npm install react-router-dom
import { Route, Routes } from "react-router-dom";
import Navbar from "./Components/NavbarItems/Navbar";
import Home from "./Routes/Home";
import AboutUs from "./Routes/AboutUs";
import AboutExecCom from "./Routes/AboutExecCom";
import ShikhaAbout from "./Routes/ShikhaAbout";
import ConstBylaws from "./Routes/ConstBylaws";
import Contact from "./Routes/ContactUs";
import MultimediaGallery from "./Routes/MultimediaGallery";
import PhotoGallery from "./Routes/ShikhaPhotoGalley";
import Membership from "./Routes/Membership";
import MembershipForm from "./Routes/MembershipForm";
import PoushVDO from "./Routes/PoushVDO";
import PhotoGallery2025 from "./Components/Multimedia/PhotoGallery2025/PhotoGallery2025";
import PhotoGallery2026 from "./Components/Multimedia/PhotoGallery2026/PhotoGallery2026";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/aboutShikha" element={<ShikhaAbout />} />
        <Route path="/execCommMem" element={<AboutExecCom />} />
        <Route path="/constitution" element={<ConstBylaws />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/multimedia" element={<MultimediaGallery />} />
        <Route path="/photoGallery" element={<PhotoGallery />} />
        <Route path="/videos" element={<PoushVDO />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/membershipForm" element={<MembershipForm />} />
        <Route path="/poush2025" element={<PhotoGallery2025 />} />
        <Route path="/poush2026" element={<PhotoGallery2026 />} />
      </Routes>
    </div>
  );
}

export default App;
